import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../utils';
import { FormFlex } from '../FormGrid';
import { Typography } from '../Typography';
const ValueTypographyStyled = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'isSmall',
})(({ isSmall, theme }) => ({
    color: isSmall ? theme.palette.secondary.main : theme.palette.secondary.dark,
}));
export const ResultCardCaption = ({ label, value, isSmall, }) => (_jsxs(FormFlex, { rowGap: 0, columnGap: 0, children: [!isSmall && _jsxs(Typography, { variant: "body2", children: [label, "\u00A0"] }), _jsx(ValueTypographyStyled, { isSmall: isSmall, variant: isSmall ? 'caption' : 'body2', children: value })] }));
